// src/features/diario/services/diarioAlteracoesService.ts
// Serviço dedicado para gerenciar threads e comentários de "Alterações de Projeto"

import { supabase } from "@/features/sistema/services/supabaseClient";

const RECURSO = "diario_alteracoes_projeto" as const;

/**
 * Garante que exista uma thread para as alterações de projeto de um relatório
 */
export async function ensureAlteracoesThread(
  obraId: string,
  relatorioId: string
): Promise<string> {
  // Buscar thread existente
  const { data: found, error: e1 } = await supabase
    .from("comment_threads")
    .select("id")
    .eq("obra_id", obraId)
    .eq("recurso", RECURSO)
    .eq("recurso_id", relatorioId)
    .maybeSingle();

  if (e1) throw e1;
  if (found) return found.id;

  // Criar nova thread
  const { data: inserted, error: e2 } = await supabase
    .from("comment_threads")
    .insert({
      obra_id: obraId,
      recurso: RECURSO,
      recurso_id: relatorioId,
    })
    .select("id")
    .single();

  if (e2) throw e2;
  return inserted.id;
}

/**
 * Cria um "comentário automático" registrando alterações de projeto
 * Usado quando há texto ou anexos em alteracoes_projeto
 */
export async function registrarAlteracao(params: {
  obraId: string;
  relatorioId: string;
  texto?: string;
  anexos?: Array<{ url: string; nome: string; tipo: string }>;
}): Promise<void> {
  const { obraId, relatorioId, texto, anexos } = params;

  // Só registra se houver conteúdo
  if (!texto?.trim() && (!anexos || anexos.length === 0)) {
    return;
  }

  // Garante que thread existe
  const threadId = await ensureAlteracoesThread(obraId, relatorioId);

  // Determina tipo baseado no conteúdo
  let tipo: "texto" | "foto" | "arquivo" = "texto";
  let arquivo_url: string | null = null;
  let arquivo_nome: string | null = null;

  if (anexos && anexos.length > 0) {
    const primeiro = anexos[0];
    tipo = primeiro.tipo === "imagem" ? "foto" : "arquivo";
    arquivo_url = primeiro.url;
    arquivo_nome = primeiro.nome;
  }

  // Cria comentário
  const { error } = await supabase
    .from("tarefas_comentarios")
    .insert({
      thread_id: threadId,
      conteudo: texto || "",
      tipo,
      arquivo_url,
      arquivo_nome,
    });

  if (error) {
    console.error("Erro ao registrar alteração:", error);
    throw error;
  }

}

